export default __webpack_public_path__ + "static/media/print-icon.22cedecd.svg";